import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { graphql, useLazyLoadQuery } from 'react-relay/hooks'
import { usePage } from 'hooks'
import { FlexColumn, SuspenseBoundary } from 'elements'
import CompanyContent from './CompanyContent'

export default function CompanyContainer() {
  const { setHeader } = usePage()
  const { companyId } = useParams()

  const data = useLazyLoadQuery(
    graphql`
      query CompanyContainerQuery($companyId: ID!) {
        companyById(id: $companyId) {
          id
          rowId
          name
          legalName
        }
      }
    `,
    { companyId },
  )

  const company = data.companyById

  useEffect(() => {
    setHeader({
      crumbs: [{ label: 'Details', value: 'details' }],
    })
  }, [setHeader, company])

  return (
    <FlexColumn bg="background.0" p="large" borderRadius="small">
      <SuspenseBoundary>
        <CompanyContent company={company} />
      </SuspenseBoundary>
    </FlexColumn>
  )
}
